var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3383_15726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.875 9.625C12.3875 10.1125 12.3875 10.8875 12.875 11.375L15.25 13.75H3.75C3.0625 13.75 2.5 14.3125 2.5 15C2.5 15.6875 3.0625 16.25 3.75 16.25H15.25L12.875 18.625C12.3875 19.1125 12.3875 19.8875 12.875 20.375C13.3625 20.8625 14.1375 20.8625 14.625 20.375L19.1125 15.8875C19.6 15.4 19.6 14.6125 19.1125 14.125L14.625 9.625C14.1375 9.1375 13.3625 9.1375 12.875 9.625ZM25 23.75H16.25C15.5625 23.75 15 24.3125 15 25C15 25.6875 15.5625 26.25 16.25 26.25H25C26.375 26.25 27.5 25.125 27.5 23.75V6.25C27.5 4.875 26.375 3.75 25 3.75H16.25C15.5625 3.75 15 4.3125 15 5C15 5.6875 15.5625 6.25 16.25 6.25H25V23.75Z",
    fill: "#5177FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3383_15726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSso);
export default __webpack_public_path__ + "static/media/sso.737e4bf79199b3a8392a0f64cb6b6b45.svg";
export { ForwardRef as ReactComponent };